import { all, call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';

import * as dailyReportActions from '@/components/dailyReport/Actions';
import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { dailyReportActionTypes } from '@/components/dailyReport/Constants';
import { ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';

import type { DailyReportData, GetDailyReportRequestAction } from '@/components/dailyReport/types';

export default function* dailyReportSaga(): Generator {
	yield all([
		yield takeLatest(dailyReportActionTypes.GET_DAILY_REPORT_REQUEST, handleDailyReportRequest),
	]);
}

export function* handleDailyReportRequest(action: GetDailyReportRequestAction) {
	const { date } = action.payload || {};

	try {
		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			ROUTES_API.DAILY_REPORT,
			'GET',
			date ? { date } : undefined,
		);

		const dailyReport = response.data as DailyReportData;

		yield put(dailyReportActions.getDailyReportSuccess(dailyReport));
	} catch (e) {
		yield put(dailyReportActions.getDailyReportError());
		yield put(errorHandlerActions.handleError(e));
	}
}
